<template>
  <div> 
    <MetaAds />
  </div>
</template>

<script>
import MetaAds from '@/components/administration/AI/meta/meta/MetaAds.vue';

export default {
  components: {
    MetaAds
  }
}
</script>

<style scoped>
</style>
